export default "__VITE_ASSET__40c66a63__"